import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";
import { PAGE_SIZE } from "../../constants/dataConstants";
import { builders } from "prettier/doc";

interface AssignABORequest {
  assignmentType: string;
  nativeId: string;
  abos: Array<{
    affiliateCode: string;
    aboNumber: string;
  }>;
}
// Define a service using a base URL and expected endpoints
export const aboAssignmentListAPI = createApi({
  reducerPath: "aboAssignmentListAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["ABOAssignmentList"],
  endpoints: (builder) => ({
    getABOAssignmentList: builder.query<any, AboAssignmentRequest>({
      query: ({ payload, pageNumber }) => ({
        url: `/am/aboassign/view?pageNumber=${pageNumber}&pageSize=${PAGE_SIZE}`,
        method: "POST",
        data: payload,
      }),
      // providesTags: (result, error,  viewId ) => [{ type: "ABOAssignmentList", viewId }],
      serializeQueryArgs: ({ queryArgs }) => {
        return `${queryArgs.viewId}`;
      }
    }),
    getABOByAffiliateAbonumber: builder.query<any, AboAssignmentRequest>({
      query: ({ payload, affiliateCode, aboNumber, pageNumber }) => ({
        url: `/am/aboassign/abo/${affiliateCode}/${aboNumber}/view?pageNumber=${pageNumber}&pageSize=${PAGE_SIZE}`,
        method: "POST",
        data: payload,
      }),
    }),
    assignABO: builder.mutation<any, AssignABORequest>({
      query: (payload) => ({
        url: `/am/aboassign/assignment`,
        method: "POST",
        data: payload,
        invalidatesTags: ["MyApprovals", "MyApprovalsDetails"],
      }),
      transformResponse: (res: {
        body: any;
        statusCode: number;
        error: {
          errorCode: number;
          errorMessage: string;
        }[];
      }) => {
        if ([200, 201].includes(res.statusCode)) return res?.body;
        throw res.error[0];
      },
      invalidatesTags: ["ABOAssignmentList"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          //window.location.reload();
        } catch (err) {
          console.error("assignABO failed", err);
        }
      },
    }),
    getAssignmentTypes: builder.query<OptionMasterResItem[], { affiliateCode: string }>({
      query: ({ affiliateCode }) => ({
        url: `/admin/optionmasters/application/amw/name/aboassign-assignmenttype/affiliate/${affiliateCode}`,
      }),
      transformResponse: (res: {
        body: any;
        statusCode: number;
        error: {
          errorCode: number;
          errorMessage: string;
        }[];
      }) => {
        if (res.statusCode === 200) return res?.body?.options ?? [];
        throw res.error[0];
      },
    }),
    getAssigneeList: builder.query<
      AuthUserItem[],
      { affiliateCode: string; typeCode: string }
    >({
      query: ({ affiliateCode, typeCode }) => ({
        url: `/auth/users/active/application/AMW/permissiongrouptype/${typeCode}/affiliate/${affiliateCode}/hatv`,
      }),
      transformResponse: (res: {
        body: any;
        statusCode: number;
        error: {
          errorCode: number;
          errorMessage: string;
        }[];
      }) => {
        if (res.statusCode === 200) return res.body;
        throw res.error[0];
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetABOAssignmentListQuery,
  useLazyGetABOByAffiliateAbonumberQuery,
  useAssignABOMutation,
  useGetAssignmentTypesQuery,
  useGetAssigneeListQuery,
} = aboAssignmentListAPI;
